/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Icons
   ========================================================================== */
.cf-icon-svg {
  height: 1.1875em;
  vertical-align: text-top;
  fill: currentcolor;
}
.cf-icon-svg--updating, .cf-icon-svg--updating-round {
  animation: updating-animation 1.25s infinite linear;
  transform-origin: 50% 50%;
}

@keyframes updating-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
html[lang=ar] .cf-icon-svg--right, html[lang=ar] .cf-icon-svg--right-round, html[lang=ar] .cf-icon-svg--left, html[lang=ar] .cf-icon-svg--left-round, html[lang=ar] .cf-icon-svg--arrow-right, html[lang=ar] .cf-icon-svg--arrow-right-round, html[lang=ar] .cf-icon-svg--arrow-left, html[lang=ar] .cf-icon-svg--arrow-left-round, html[lang=ar] .cf-icon-svg--help, html[lang=ar] .cf-icon-svg--help-round, html[lang=ar] .cf-icon-svg--book, html[lang=ar] .cf-icon-svg--book-round, html[lang=ar] .cf-icon-svg--document, html[lang=ar] .cf-icon-svg--document-round, html[lang=ar] .cf-icon-svg--edit, html[lang=ar] .cf-icon-svg--edit-round, html[lang=ar] .cf-icon-svg--paper-clip, html[lang=ar] .cf-icon-svg--paper-clip-round, html[lang=ar] .cf-icon-svg--cart, html[lang=ar] .cf-icon-svg--cart-round, html[lang=ar] .cf-icon-svg--disability, html[lang=ar] .cf-icon-svg--disability-round, html[lang=ar] .cf-icon-svg--travel, html[lang=ar] .cf-icon-svg--travel-round, html[lang=ar] .cf-icon-svg--bullhorn, html[lang=ar] .cf-icon-svg--bullhorn-round, html[lang=ar] .cf-icon-svg--chart, html[lang=ar] .cf-icon-svg--chart-round, html[lang=ar] .cf-icon-svg--list, html[lang=ar] .cf-icon-svg--list-round, html[lang=ar] .cf-icon-svg--external-link, html[lang=ar] .cf-icon-svg--external-link-round {
  transform: scaleX(-1);
}